import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { validateAddressInputs } from '../../lib/validator';
import { RegionDropdown } from 'react-country-region-selector';
import { splitGoogleAddressComponents } from '../../lib/helper';
import defaultMsg from '../../translations/lang/en-US.json';

class UserAddressFields extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.parseData = this.parseData.bind(this);
    this.saveAddress = this.saveAddress.bind(this);
    this.selectState = this.selectState.bind(this);

    this.state = Object.assign(
      {},
      this.parseData(this.props),
      this.validInputStates(this.props.formState || this.props)
    );
  }

  componentWillMount() {
    this.props.onChange(
      Object.assign(
        {},
        this.parseData(this.props, true),
        this.validInputStates(this.props.formState || this.props)
      ),
      false
    );
  }

  componentWillReceiveProps(nextProps) {
    this.setState(
      Object.assign(
        {},
        this.parseData(nextProps),
        this.validInputStates(nextProps.formState || nextProps)
      )
    );
  }

  componentDidMount() {
    const google = window.google;
    const autocomplete = new google.maps.places.Autocomplete(
      this.refs.streetAddress
    );
    autocomplete.addListener(
      'place_changed',
      function() {
        const place = autocomplete.getPlace();
        const googleSuggestion = Object.assign(
          {},
          { isValidStreetAddress: true },
          splitGoogleAddressComponents(place.address_components)
        );
        this.setState(googleSuggestion);
      }.bind(this)
    );
  }

  selectState(value) {
    this.setState({ state: value });
  }

  parseData(data, fetching = false) {
    const addressDetails = data.formState || data;
    if (fetching === true) {
      const currentState = Object.assign({}, data);
      currentState['zipcode'] = currentState['zipCode'];
      currentState['address_2'] = currentState['apartmentOrBuildingDetails'];
      currentState['address_1'] = currentState['streetAddress'];
      currentState['id'] = currentState['addressId'];
      currentState['user_id'] = currentState['userId'];
      currentState['name'] = currentState['addressName'];
      currentState['is_primary'] = currentState['isPrimary'];
      return currentState;
    } else {
      return {
        streetAddress: addressDetails.address || addressDetails.address_1 || '',
        country:
          (addressDetails.country && addressDetails.country.length > 3
            ? addressDetails.country
            : false) || '',
        countryShortName: 'US',
        stateShortName: '',
        apartmentOrBuildingDetails:
          addressDetails.apartmentOrBuildingDetails ||
          addressDetails.address_2 ||
          '',
        zipCode: addressDetails.zipCode || addressDetails.zipcode || '',
        city: addressDetails.city || '',
        state: addressDetails.state || '',
        userId: addressDetails.userId || addressDetails['user_id'] || 0,
        addressId: addressDetails.addressId || addressDetails.id || 0,
        addressName: addressDetails.addressName || addressDetails.name || '',
        isPrimary:
          addressDetails.isPrimary || addressDetails['is_primary'] || 0,
      };
    }
  }

  getIsValidatorString(type) {
    return `isValid${type[0].toUpperCase() + type.slice(1)}`;
  }

  handleChange(e, type) {
    let stateAssignment = {};
    stateAssignment[type] = e.target.value;
    stateAssignment[this.getIsValidatorString(type)] = true;
    this.setState(stateAssignment, function() {
      if (this.props.onChange) {
        this.props.onChange(this.parseData(this.state, true));
      }
    });
  }

  validInputStates(props) {
    return {
      isValidApartmentOrBuildingAddress:
        props.isValidApartmentOrBuildingAddress === false ? false : true,
      isValidStreetAddress: props.isValidStreetAddress === false ? false : true,
      isValidCity: props.isValidCity === false ? false : true,
      isValidState: props.isValidState === false ? false : true,
      isValidZipCode: props.isValidZipCode === false ? false : true,
      isValidAddressName: props.isValidAddressName === false ? false : true,
    };
  }

  validateInputs(e, type) {
    const userInput = e.target.value;
    let validatorStatus = {};
    validatorStatus[this.getIsValidatorString(type)] = validateAddressInputs(
      userInput,
      type,
      this.props.optional
    );
    this.setState(validatorStatus);
  }

  saveAddress(data) {
    const fields = [
      'addressName',
      'streetAddress',
      'apartmentOrBuildingDetails',
      'city',
      'state',
      'zipCode',
    ];
    let validatorStatus = {};
    let status = true;
    if (this.props.optional !== true) {
      for (let i = 0; i < fields.length; i++) {
        let name = this.getIsValidatorString(fields[i]);
        validatorStatus[name] = validateAddressInputs(
          this.state[fields[i]],
          fields[i]
        );
        if (!validatorStatus[name] && status === true) {
          status = false;
        }
      }
    }
    if (status) {
      this.props.saveAddress(data);
    } else {
      this.setState(validatorStatus);
    }
  }

  render() {
    const { country = 'United States', state } = this.state;

    return (
      <div
        className={`user-address-form ${
          this.props.reduceLabelFont ? 'reduce-label-fonts' : ''
        }`}
      >
        <div className="row">
          <div
            className={`${
              this.state.isValidAddressName === false ? 'has-error' : ''
            } col-lg-12 col-md-12 col-sm-12 col-xs-12`}
          >
            <div className="form-group">
              <label htmlFor="address_name" className="control-label">
                <FormattedMessage
                  id="enterAddressName"
                  defaultMessage={defaultMsg.enterAddressName}
                />
                {this.props.optional !== true ? (
                  <mark className="mark-style"> * </mark>
                ) : null}
              </label>
              <input
                type="text"
                className="form-control"
                id="address_name"
                placeholder={this.props.intl.formatMessage({
                  id: 'placeholderEnterAddressName',
                  defaultMessage: defaultMsg.placeholderEnterAddressName
                })}
                onChange={e => this.handleChange(e, 'addressName')}
                onFocus={e => this.handleChange(e, 'addressName')}
                onBlur={e => this.validateInputs(e, 'addressName')}
                value={this.state.addressName}
                disabled={this.props.save === true ? false : true}
              />
              {!this.state.isValidAddressName ? (
                <span
                  className="help-block no-border"
                  style={{ fontSize: '12px' }}
                >
                <FormattedMessage
                  id="errorAddressName"
                  defaultMessage={defaultMsg.errorAddressName}
                />
                </span>
              ) : null}
            </div>
          </div>
        </div>
        <div className="row">
          <div
            className={`${
              this.state.isValidStreetAddress === false ? 'has-error' : ''
            } col-lg-12 col-md-12 col-sm-12 col-xs-12`}
          >
            <div className="form-group">
              <label htmlFor="streetAddress" className="control-label">
                <FormattedMessage
                  id="enterStreetAddress"
                  defaultMessage={defaultMsg.enterStreetAddress}
                />
                {this.props.optional !== true ? (
                  <mark className="mark-style"> * </mark>
                ) : null}
              </label>
              <input
                type="text"
                className="form-control"
                id="streetAddress"
                ref="streetAddress"
                placeholder={this.props.intl.formatMessage({
                  id: 'placeholderEnterStreetAddress',
                  defaultMessage: defaultMsg.placeholderEnterStreetAddress
                })}
                onChange={e => this.handleChange(e, 'streetAddress')}
                onFocus={e => this.handleChange(e, 'streetAddress')}
                onBlur={e => this.validateInputs(e, 'streetAddress')}
                value={this.state.streetAddress}
                disabled={this.props.save === true ? false : true}
                max={255}
              />
              {!this.state.isValidStreetAddress ? (
                <span
                  className="help-block no-border"
                  style={{ fontSize: '12px' }}
                >
                <FormattedMessage
                  id="errorStreetAddress"
                  defaultMessage={defaultMsg.errorStreetAddress}
                />
                </span>
              ) : null}
            </div>
          </div>
        </div>
        <div className="row">
          <div
            className={`${
              this.state.isValidApartmentOrBuildingAddress === false
                ? 'has-error'
                : ''
            } col-lg-12 col-md-12 col-sm-12 col-xs-12`}
          >
            <div className="form-group">
              <label htmlFor="Address" className="control-label">
                <FormattedMessage
                  id="enterApartmentOrBuildingAddress"
                  defaultMessage={defaultMsg.enterApartmentOrBuildingAddress}
                />
              </label>
              <input
                type="text"
                className="form-control"
                id="apartmentOrBuildingDetails"
                placeholder={this.props.intl.formatMessage({
                  id: 'placeholderEnterApartmentOrBuildingAddress',
                  defaultMessage: defaultMsg.placeholderEnterApartmentOrBuildingAddress
                })}
                onChange={e =>
                  this.handleChange(e, 'apartmentOrBuildingDetails')
                }
                onFocus={e =>
                  this.handleChange(e, 'apartmentOrBuildingDetails')
                }
                onBlur={e =>
                  this.validateInputs(e, 'apartmentOrBuildingDetails')
                }
                value={this.state.apartmentOrBuildingDetails}
                disabled={this.props.save === true ? false : true}
                max={255}
              />
              {!this.state.isValidApartmentOrBuildingAddress ? (
                <span
                  className="help-block no-border"
                  style={{ fontSize: '12px' }}
                >
                <FormattedMessage
                  id="errorApartmentOrBuildingAddress"
                  defaultMessage={defaultMsg.errorApartmentOrBuildingAddress}
                />
                </span>
              ) : null}
            </div>
          </div>
        </div>
        <div className="row">
          <div
            className={`${
              this.state.isValidCity === false ? 'has-error' : ''
            } col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group`}
          >
            <label htmlFor="city" className="control-label">
              <FormattedMessage
                id="enterTownOrCity"
                defaultMessage={defaultMsg.enterTownOrCity}
              />
              {this.props.optional !== true ? (
                <mark className="mark-style"> * </mark>
              ) : null}
            </label>
            <input
              className="form-control cust-style"
              id="city"
              onChange={e => this.handleChange(e, 'city')}
              onFocus={e => this.handleChange(e, 'city')}
              onBlur={e => this.validateInputs(e, 'city')}
              type="text"
              placeholder={this.props.intl.formatMessage({
                id: 'placeholderEnterTownOrCity',
                defaultMessage: defaultMsg.placeholderEnterTownOrCity
              })}
              value={this.state.city}
              disabled={this.props.save === true ? false : true}
            />
            {!this.state.isValidCity ? (
              <span
                className="help-block no-border"
                style={{ fontSize: '12px' }}
              >
              <FormattedMessage
                id="errorTownOrCity"
                defaultMessage={defaultMsg.errorTownOrCity}
              />
              </span>
            ) : null}
          </div>
        </div>

        <div className="row">
          <div
            className={`${
              this.state.isValidState === false ? 'has-error' : ''
            } col-lg-6 col-md-6 col-sm-6 col-xs-12`}
          >
            <label htmlFor="state" className="control-label">
              <FormattedMessage
                id="selectStateOrProvince"
                defaultMessage={defaultMsg.selectStateOrProvince}
              />
              {this.props.optional !== true ? (
                <mark className="mark-style"> * </mark>
              ) : null}
            </label>
            <RegionDropdown
              blankOptionLabel={this.props.intl.formatMessage({
                id: 'placeholderSelectStateOrProvince',
                defaultMessage: defaultMsg.placeholderSelectStateOrProvince
              })}
              defaultOptionLabel={this.props.intl.formatMessage({
                id: 'placeholderSelectStateOrProvince',
                defaultMessage: defaultMsg.placeholderSelectStateOrProvince
              })}
              country={country}
              value={state}
              disabled={this.props.save === true ? false : true}
              onChange={value => this.selectState(value)}
              onBlur={e => this.validateInputs(e, 'state')}
              onFocus={e => this.handleChange(e, 'state')}
              id="state"
              classes="form-control cust-style"
            />
            {!this.state.isValidState ? (
              <span
                className="help-block no-border"
                style={{ fontSize: '12px' }}
              >
              <FormattedMessage
                id="errorStateOrProvince"
                defaultMessage={defaultMsg.errorStateOrProvince}
              />
              </span>
            ) : null}
          </div>

          <div
            className={`${
              this.state.isValidZipCode === false ? 'has-error' : ''
            } col-lg-6 col-md-6 col-sm-6 col-xs-12`}
          >
            <label htmlFor="zipcode" className="control-label">
              <FormattedMessage
                id="enterZipCodeOrPostalCode"
                defaultMessage={defaultMsg.enterZipCodeOrPostalCode}
              />
              {this.props.optional !== true ? (
                <mark className="mark-style"> * </mark>
              ) : null}
            </label>
            <input
              className="form-control cust-style"
              id="zipcode"
              onChange={e => this.handleChange(e, 'zipCode')}
              onFocus={e => this.handleChange(e, 'zipCode')}
              onBlur={e => this.validateInputs(e, 'zipCode')}
              type="text"
              maxLength="8"
              placeholder={this.props.intl.formatMessage({
                id: 'placeholderEnterZipCodeOrPostalCode',
                defaultMessage: defaultMsg.placeholderEnterZipCodeOrPostalCode
              })}
              value={this.state.zipCode}
              disabled={this.props.save === true ? false : true}
            />
            {!this.state.isValidZipCode ? (
              <span
                className="help-block no-border"
                style={{ fontSize: '12px' }}
              >
              <FormattedMessage
                id="errorZipCodeOrPostalCode"
                defaultMessage={defaultMsg.errorZipCodeOrPostalCode}
              />
              </span>
            ) : null}
          </div>
        </div>
        {this.props.saveAddress && this.props.save === true ? (
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right">
              <div className="btn-group">
                <button
                  type="button"
                  onClick={() =>
                    this.saveAddress(this.parseData(this.state, true))
                  }
                  className="btn btn-success olo-client-theme-color-white olo-client-theme-background"
                >
                  <FormattedMessage
                    id="saveChanges"
                    defaultMessage={defaultMsg.saveChanges}
                  />
                </button>
                <button
                  type="button"
                  className="btn btn-default olo-client-theme-color"
                  onClick={this.props.cancel}
                >
                  <FormattedMessage
                    id="cancel"
                    defaultMessage={defaultMsg.cancel}
                  />
                </button>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default injectIntl(UserAddressFields);


// WEBPACK FOOTER //
// ./src/views/myaccount/UserAddressFields.jsx